/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const TextMessages = {
  ROUTE_RENEWALS: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        1113
      ]
    }],
  },
  ROUTE_MANAGEMENT: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        34,
        35,
        775,
        776,
        777,
        778,
        779,
        780,
        781,
        782,
        783,
        784,
        785,
        786,
        791,
        792,
        796,
        795,
        799,
        797,
        861,
        862,
        836,
        794,
        802,
        789,
        800,
        801,
        791,
        792,
        793,
        803,
        838,
        839,
        840,
        783,
        795,
        796,
        797,
        799,
        839,
        840,
        847,
        848,
        849,
        863,
        864,
        865,
        866,
        867,
        910,
        911,
        912,
        913,
        914,
        915,
        916,
        917,
        922,
        923,
        924,
        936,
        935,
        937,
        938,
        939,
        940,
        920,
        921,
        925,
        926,
        927,
        928,
        944,
        945,
        946,
        876,
        947,
        948,
        949,
        989,
        991,
        1074,
        1075,
        1121,
        1122,
        1141,
        1142,
        1143,
        1144,
        830,
        1165,
        1167,
        1168,
        822,
        1281,
        1309,
        1310,
        1311,
      ]
    }]
  },
  ROUTE_MANAGEMENT_DOCUMENT_PARAMS: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        759,
        791,
        1129,
        1130,
        1131,
        1134,
        1135,
        1139,
        1290,
        1291,
        1292,
        1293,
        1294,
        1295,
      ]
    }]
  },
  ROUTE_MANAGEMENT_PERSON: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        30,
        31,
        32,
        33,
        251,
        282,
        754,
        755,
        756,
        757,
        758,
        759,
        760,
        761,
        762,
        763,
        764,
        765,
        770,
        771,
        791,
        800,
        801,
        804,
        805,
        806,
        807,
        808,
        809,
        810,
        811,
        812,
        813,
        814,
        815,
        816,
        817,
        818,
        819,
        820,
        821,
        822,
        823,
        824,
        825,
        826,
        827,
        828,
        829,
        830,
        841,
        842,
        843,
        844,
        845,
        846,
        850,
        851,
        852,
        853,
        854,
        855,
        856,
        857,
        858,
        859,
        860,
        866,
        867,
        896,
        989,
        990,
        991,
        1008,
        1017,
        1018,
        1019,
        1076,
        1068,
        1072,
        1077
      ]
    }]
  },
  ROUTE_MANAGEMENT_USER: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        859,
        755,
        806,
        853,
        851,
        860,
        758,
        759,
        765,
        763,
        762,
        1017,
        1018,
        1019,
        760,
        764,
        761,
        852,
        800,
        801,
        827,
        855,
        896,
        856,
        815,
        816
      ]
    }]
  },
  ROUTE_MANAGEMENT_ACCESS_ROLE: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        758,
        759,
        760,
        761,
        762,
        763,
        764,
        765,
        787,
        788,
        789,
        1005,
        1020
      ]
    }]
  },
  ROUTE_MANAGEMENT_ACCESS_GROUP: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        758,
        759,
        760,
        761,
        762,
        763,
        764,
        795,
        797,
        783,
        831,
        832,
        833,
        834,
        835,
        868,
        869,
        870,
        871,
        872,
        873,
        1010,
        1011
      ]
    }]
  },
  ROUTE_MANAGEMENT_ECONOMIC_INDEXERS: {
    domainIds: [357],
    models: [{
      modelName: 'DOMAINS',
      modelItemIds: [
        1122,
        1129,
        1130,
        1131,
        1132,
        1133,
        1134,
        1135,
        1136,
        1137,
        1138,
        1139,
        1140,
        1141,
        1142,
        1143,
        1144,
        830,
        758
      ]
    }]
  }
}

export default TextMessages;